/* eslint-env es2020 */

((OP) => {
  // Sticky
  window.OP.scrollCallbacks.push((currentScrollTop) => {
    document.querySelectorAll('.main-header').forEach((header) => {
      header.classList[currentScrollTop > 0 ? 'add' : 'remove']('sticky');
      document.body.classList[currentScrollTop > 0 ? 'add' : 'remove']('has-menu-sticky');
    });
  });
  const scrollToElement = (selector) => {
    const elements = document.querySelectorAll(selector || '.layout-content');
    if (elements.length) {
      window.scrollTo({
        top: window.scrollY + elements[0].getBoundingClientRect().top - 110,
        behavior: 'smooth',
      });
    }
  };
  OP.onLoad(() => {
    // Menu
    const toggleCheckbox = (checkbox) => {
      checkbox.checked = !checkbox.checked;
    };
    document.querySelectorAll('.menu-toggle').forEach((togglr) => {
      document.querySelectorAll(`input[name="${togglr.attributes.for.value}"]`).forEach((checkbox) => {
        checkbox.checked = false;
      });
      togglr.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelectorAll(`input[name="${togglr.attributes.for.value}"]`).forEach(toggleCheckbox);
      });
    });
    // Autoload videos modals
    [].forEach.call(document.querySelectorAll('.modal-slick'), (el) => {
      el.addEventListener('shown.bs.modal', () => {
        let event;
        if (typeof window.CustomEvent === 'function') {
          event = new CustomEvent('resize', null);
        } else {
          event = document.createEvent('CustomEvent');
          event.initCustomEvent('resize', true, true, null);
        }
        window.dispatchEvent(event);
      });
    });
    [].forEach.call(document.querySelectorAll('.modal-autoload'), (el) => {
      el.addEventListener('shown.bs.modal', () => {
        [].forEach.call(document.querySelectorAll('[data-src]'), (elAutoload) => {
          if (!elAutoload.src) {
            elAutoload.src = elAutoload.dataset.src;
          }
          if (elAutoload.parentNode.tagName === 'VIDEO') {
            elAutoload.parentNode.load();
          }
        });
      });
      el.addEventListener('hide.bs.modal', () => {
        [].forEach.call(document.querySelectorAll('[data-src], iframe'), (elAutoload) => {
          if (elAutoload.src) {
            elAutoload.dataset.src = elAutoload.src;
            elAutoload.removeAttribute('src');
          }
        });
      });
    });
    // Header search
    [].forEach.call(document.querySelectorAll('.op-search'), (el) => {
      el.addEventListener('shown.bs.dropdown', () => {
        if (el.querySelector('input')) {
          el.querySelector('input').focus();
        }
      });
    });
  });
  document.addEventListener('op.search.refresh', () => {
    scrollToElement('[data-search-list]');
  });
})(window.OP);
